var _rect, _rect2, _path, _path2, _path3, _path4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGaugeWidget = function SvgGaugeWidget(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 129,
    viewBox: "0 0 156 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 109,
    width: 78,
    height: 8,
    rx: 4,
    fill: "#E4E8EE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 125,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#E4E8EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0091 77C23.1342 70.1179 24.5502 63.3172 27.1866 56.9524C29.9506 50.2795 34.0019 44.2164 39.1091 39.1091C44.2164 34.0019 50.2795 29.9506 56.9524 27.1866C63.6253 24.4226 70.7773 23 78 23C85.2227 23 92.3747 24.4226 99.0476 27.1866C105.72 29.9506 111.784 34.0019 116.891 39.1091C121.998 44.2164 126.049 50.2795 128.813 56.9524C131.45 63.3172 132.866 70.1179 132.991 77L154.993 77C154.867 67.2286 152.881 57.5674 149.139 48.5334C145.269 39.1913 139.597 30.7029 132.447 23.5528C125.297 16.4027 116.809 10.7309 107.467 6.86128C98.1245 2.99167 88.1118 1 78 1C67.8882 1 57.8754 2.99167 48.5334 6.86128C39.1913 10.7309 30.7029 16.4027 23.5528 23.5528C16.4027 30.7029 10.7309 39.1913 6.86128 48.5334C3.11927 57.5674 1.1334 67.2286 1.0065 77L23.0091 77Z",
    fill: "#C9CFD3",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.991 77C132.816 67.3836 130.122 57.9746 125.17 49.7159C120.046 41.1711 112.698 34.1785 103.909 29.4851C95.121 24.7916 85.2227 22.5735 75.2717 23.0677C65.6539 23.5454 56.3361 26.5395 48.247 31.7425L36.0098 13.4568C47.4123 6.03863 60.5821 1.77019 74.1804 1.09482C88.1117 0.402897 101.969 3.5082 114.273 10.0791C126.577 16.6499 136.865 26.4395 144.038 38.4023C151.04 50.079 154.817 63.3981 154.994 77L132.991 77Z",
    fill: "#A2A5AD",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.991 77C132.811 67.1216 129.974 57.4671 124.768 49.0554C119.562 40.6438 112.187 33.7973 103.426 29.2299L113.241 9.53781C125.662 15.9316 136.116 25.5878 143.475 37.4776C150.833 49.3674 154.812 63.031 154.994 77L132.991 77Z",
    fill: "#5F6469",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75C84 78.3137 81.3137 81 78 81C74.6863 81 72 78.3137 72 75C72 71.6863 78 18.5 78 18.5C78 18.5 84 71.6863 84 75Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 75,
    r: 3,
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGaugeWidget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "gauge-widget.eadcda52e12f62aff7f401874c6a1c3a.svg";